var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TimelineItem',{attrs:{"date":_vm.date,"show-full-date":_vm.differentDateThanPrevious},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('i',{class:_vm.icon})]},proxy:true}])},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }